import { render, staticRenderFns } from "./IndividualHAOP.vue?vue&type=template&id=64c5ec5a&scoped=true&"
import script from "./IndividualHAOP.vue?vue&type=script&lang=ts&"
export * from "./IndividualHAOP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5ec5a",
  null
  
)

export default component.exports